import { trans } from '../localization';

export const BUTTONS = {
    SAVE: {
        NAME: 'save',
        TEXT: 'Save',
        ICON: 'far fa-check',
        CLASSES: 'btn btn-success'
    },
    SAVE_BACK_TO_INDEX: {
        NAME: 'save-back-to-index',
        TEXT: 'Save and back to index',
        ICON: 'far fa-check',
        CLASSES: 'btn btn-success'
    },
    SAVE_CONCEPT: {
        NAME: 'save-as-concept',
        TEXT: 'Save as concept',
        ICON: 'far fa-check',
        CLASSES: 'btn btn-primary'
    },
    SAVE_AND_APPROVE: {
        NAME: 'save-and-approve',
        TEXT: 'Save and Approve',
        ICON: 'far fa-thumbs-up',
        CLASSES: 'btn btn-primary'
    },
    BACK: {
        NAME: 'back',
        TEXT: 'Back',
        ICON: 'far fa-arrow-left',
        CLASSES: 'btn btn-default'
    },
    CREATE: {
        NAME: 'create',
        TEXT: 'Create',
        ICON: 'far fa-check',
        CLASSES: 'btn btn-primary'
    },
    ADD: {
        NAME: 'add',
        TEXT: 'Add',
        ICON: 'fal fa-plus',
        CLASSES: 'btn btn-primary'
    },
    EDIT: {
        NAME: 'edit',
        TEXT: 'Edit',
        ICON: 'fal fa-pencil-alt',
        CLASSES: 'btn btn-default',
    },
    DELETE: {
        NAME: 'delete',
        TEXT: 'Delete',
        ICON: 'fal fa-trash-alt',
        CLASSES: 'btn btn-danger'
    },
    REFRESH: {
        NAME: 'refresh',
        TEXT: 'Refresh',
        ICON: 'fal fa-sync',
        CLASSES: 'btn btn-default'
    },
    DUPLICATE: {
        NAME: 'duplicate',
        TEXT: 'Duplicate',
        ICON: 'fal fa-clone',
        CLASSES: 'btn btn-default'
    },
    CANCEL: {
        NAME: 'cancel',
        TEXT: 'Cancel',
        ICON: 'fal fa-times',
        CLASSES: 'btn btn-default'
    }
};

export function button(button: { NAME: string, TEXT: string, ICON: string, CLASSES: string }, properties: { [key: string]: any } = {}): any {
    return Object.assign({
        name: button.NAME,
        text: trans(button.TEXT),
        icon: button.ICON,
        classes: button.CLASSES,
    }, properties);
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/buttons.ts